import { t } from 'i18next';
import * as yup from 'yup';

export const reassignQuoteSchema = () =>
  yup.object().shape({
    corporateUser: yup.object().label(t('labelUser')).nullable().required(),
  });
